import { Page } from "@/models/page-models/Page";

export const MonthClosing: Page = {
  "path": "month-closing",
  "name": "Month Closing",
  "props": {
    "data": {
      "title": "Month Closing",
      "printable": "FALSE",
      "url": "month-closing",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.month",
                  "label": "Select Month",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.possibleMonths.data}}",
                  "items": "fetchedData.possibleMonths.data"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Close Month",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "closeMonth"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getPossibleMonths"
      }
    ],
    "functions": [
      {
        "name": "getPossibleMonths",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/monthclosing/possible-months",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.possibleMonths"
      },
      {
        "name": "closeMonth",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/monthclosing/close",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "redirectUrl",
        "arg3Value": "/aging-report"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": true
}